import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Phone, Euro, MapPin } from 'lucide-react';
import Breadcrumbs from '../components/Breadcrumbs';
import { ratgeber } from '../data/stadtteile';

const RatgeberHub = () => {
  const phone = '+4923139085116';
  const displayPhone = '0231 39085116';

  return (
    <>
      <Helmet>
        <title>Ratgeber – Schlüsseldienst Dortmund</title>
        <meta name="description" content="Hilfreiche Tipps und Anleitungen rund um Türschlösser, Sicherheit und Schlüsseldienste." />
        <link rel="canonical" href="https://schluesseldienst.services/ratgeber/" />
      </Helmet>
      
      <div className="container mx-auto px-4 py-12">
        <Breadcrumbs items={[{ label: 'Ratgeber' }]} />
        
        <h1 className="text-4xl sm:text-5xl font-bold mb-8">Ratgeber</h1>
        
        <div className="max-w-4xl">
          <p className="text-lg text-gray-700 mb-12">
            Hilfreiche Tipps und Anleitungen rund um Türschlösser, Sicherheit und Notfälle. 
            Erfahren Sie von unseren Experten, wie Sie sich optimal schützen und im Notfall richtig handeln.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
            {ratgeber.map((article) => (
              <Link
                key={article.slug}
                to={`/ratgeber/${article.slug}/`}
                className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-all border border-gray-200 hover:border-orange-300"
              >
                <h2 className="text-2xl font-bold mb-3 text-gray-900">{article.title}</h2>
                <p className="text-gray-600 mb-4">{article.excerpt}</p>
                <span className="text-orange-600 font-semibold">Mehr lesen →</span>
              </Link>
            ))}
          </div>

          {/* Internal Links Section */}
          <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-8 border-2 border-orange-200">
            <h2 className="text-2xl font-bold mb-4 text-center text-gray-900">Benötigen Sie schnelle Hilfe?</h2>
            <p className="text-center text-gray-700 mb-6">
              Unsere Experten sind 24/7 für Sie erreichbar. Festpreise ohne versteckte Kosten.
            </p>
            <div className="flex justify-center mb-6">
              <a
                href={`tel:${phone}`}
                className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-4 rounded-full font-bold text-lg transition-all shadow-lg hover:shadow-xl flex items-center gap-2"
              >
                <Phone size={24} />
                {displayPhone}
              </a>
            </div>
            <div className="flex flex-wrap justify-center gap-4">
              <Link
                to="/preise"
                className="inline-flex items-center gap-2 bg-white px-6 py-3 rounded-full text-sm font-semibold text-gray-700 hover:bg-orange-600 hover:text-white transition-all shadow hover:shadow-md"
              >
                <Euro size={18} />
                Preise ansehen
              </Link>
              <Link
                to="/einsatzgebiete"
                className="inline-flex items-center gap-2 bg-white px-6 py-3 rounded-full text-sm font-semibold text-gray-700 hover:bg-orange-600 hover:text-white transition-all shadow hover:shadow-md"
              >
                <MapPin size={18} />
                Alle Stadtteile
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RatgeberHub;
